import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from "@angular/core";
import { ControlValueAccessor, UntypedFormBuilder, UntypedFormGroup, NG_VALUE_ACCESSOR } from "@angular/forms";
import { CacheService } from "@delon/cache";
import { TranslateService } from "@root/shared/service/translate.service";

export const V4_ROOM_TYPES_SELECT_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => V4RoomTypesSelectComponent),
  multi: true,
};
@Component({
  selector: "v4-room-types-select",
  templateUrl: "./room-types-select.component.html",
  styleUrls: ["./room-types-select.component.scss"],
  providers: [V4_ROOM_TYPES_SELECT_VALUE_ACCESSOR],
})
export class V4RoomTypesSelectComponent implements OnInit, ControlValueAccessor {
  readonly listApi = "/api/house_type/list";
  selectedValues: number[];
  @Input() mode: "single" | "multi" = "multi";
  @Input() size: "default" | "large" = "default";
  @Input() placeholder = "router.static.house_type";

  /**
   *
   * 下面的属性主要用于非form表单的场景
   * 比如独立使用该组件，仅关注选中事件，而不关注值本身的情况下，可以使用这个属性
   * Output返回的是Option[]，而不是number[]，是因为在独立使用该组件的情况下，可能需要获取更多的信息，因此将Option[]返回，而不是仅仅返回id
   *
   * 对于form表单场景，使用 formControlName 或者 ngModel 即可，无需关注这个属性
   *
   */
  @Output() onSelectValues = new EventEmitter<Option[]>();

  dropdownVisible = false;
  listOfData: Option[] = [];
  form: UntypedFormGroup = this.fb.group({
    house_tag_id: null,
  });

  showTextItem = false;
  listOfTagOption: Option[];

  get tagId() {
    return this.form.get("house_tag_id").value;
  }

  get textItem() {
    if (this.mode === "multi") {
      const total = this.selectedValues?.length;
      if (total > 1) {
        return this.t.t("house.house_type_display.type_total", { total });
      } else {
        return this.t.t("house.house_type_display.type_total_singular", { total });
      }
    } else {
      return this.listOfData?.find((item) => item.value === this.selectedValues?.[0])?.label;
    }
  }

  _registerOnChange: (value: any) => void = (v: any) => {};
  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private t: TranslateService,
    private cache: CacheService,
  ) {}

  writeValue(value: any | any[]): void {
    if (!value || value?.length === 0) {
      this.selectedValues = null;
      this.showTextItem = false;
    } else {
      if (!Array.isArray(value)) {
        this.selectedValues = [value];
      } else {
        this.selectedValues = value;
      }
      this.showTextItem = true;
    }

    console.log("writeValue: ", value, " selectedValues: ", this.selectedValues);
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {}

  ngOnInit() {
    this.fetchTagList();
    this.fetchDataList();

    this.subscribeFormChange();
  }

  private subscribeFormChange() {
    this.form.valueChanges.subscribe(() => {
      this.fetchDataList();
    });
  }

  private fetchTagList() {
    return this.cache
      .get("/api/house_status_setting/get", { mode: "promise", type: "m", expire: 1 * 60 })
      .subscribe((rst: any) => {
        const list = rst?.data?.house_tag ?? [];
        this.listOfTagOption = list.map((item) => ({
          label: item.name,
          value: item.id,
        }));
      });
  }

  fetchDataList() {
    const value = this.form.value;
    const params = {
      ...value,
      page: 1,
      page_size: 10000,
    };
    if (value.house_tag_id) {
      Object.assign(params, {
        house_tag_type: "include",
        house_tag_id: JSON.stringify([value.house_tag_id]),
      });
    }
    this.http.get(this.listApi, { params }).subscribe((rst: any) => {
      this.listOfData = rst?.data?.list?.map((item) => ({
        label: item.title,
        value: item.id,
      }));
      console.log("listOfData: ", this.listOfData);
    });
  }

  private emitValues() {
    if (this.mode === "multi") {
      this._registerOnChange(this.selectedValues);
    } else {
      this._registerOnChange(this.selectedValues?.[0]);
    }
  }

  /** 仅用于单选模式，多选模式的交互需要确认，不需要响应select事件 */
  onSelect(option: Option[]) {
    console.log("on select: ", option);

    if (this.mode === "single") {
      this.onConfirm(option);
    }
  }

  onConfirm(options: Option[]) {
    const values = options.map((opt) => opt.value);
    this.selectedValues = values;
    this.showTextItem = values?.length !== 0;

    this.onSelectValues.emit(options);
    this.emitValues();
    this.dropdownVisible = false;
    // this.modalRef.destroy(options);
    console.log("onConfirm: ", options);
  }

  onCancel() {
    this.dropdownVisible = false;
    // this.modalRef.destroy();
  }

  onReset() {
    this.form.reset();
    this.selectedValues = [];
    this.showTextItem = false;

    if (this.mode === "single") {
      this.emitValues();
      this.dropdownVisible = false;
    }
  }
}
